export default __webpack_public_path__ + "static/media/new-msg-landing.26eb38a2.svg";